"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueTypeMap = exports.DEFAULT_TIME_ZONE = exports.NO_COVER_FIELD_ID = void 0;
const types_1 = require("../types");
const env_1 = require("../utils/env");
// album(gallery) view has no cover field ID
exports.NO_COVER_FIELD_ID = 'NO_COVER_FIELD_ID';
exports.DEFAULT_TIME_ZONE = (0, env_1.isServer)() && (process.env.TZ || process.env.TIMEZONE) || 'America/Toronto';
exports.ValueTypeMap = {
    [types_1.BasicValueType.Number]: 'number',
    [types_1.BasicValueType.String]: 'string',
    [types_1.BasicValueType.Boolean]: 'boolean',
    [types_1.BasicValueType.Array]: 'array',
    [types_1.BasicValueType.DateTime]: 'string',
};
//# sourceMappingURL=constants.js.map